/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is GC skew?`)
};

const es_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el sesgo GC?`)
};

const de_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist GC-Skew?`)
};

const nl_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is GC-skew?`)
};

const fr_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le biais GC ?`)
};

const it_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è lo skew GC?`)
};

const pt_br2_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é GC skew?`)
};

const pt_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a assimetria GC?`)
};

const ja_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GCスキューとは何ですか？`)
};

const zh_gcskew_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 GC 偏斜？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_q1", locale)
	if (locale === "en") return en_gcskew_faq_q1(inputs)
	if (locale === "es") return es_gcskew_faq_q1(inputs)
	if (locale === "de") return de_gcskew_faq_q1(inputs)
	if (locale === "nl") return nl_gcskew_faq_q1(inputs)
	if (locale === "fr") return fr_gcskew_faq_q1(inputs)
	if (locale === "it") return it_gcskew_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_q1(inputs)
	if (locale === "pt") return pt_gcskew_faq_q1(inputs)
	if (locale === "ja") return ja_gcskew_faq_q1(inputs)
	return zh_gcskew_faq_q1(inputs)
};